// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  return (
<footer className="App-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Tharpe Industries</h3>
          <p className="tagline">Your Trusted IT Partner in Shreveport-Bossier</p>
          <div className="contact-info">
            <p><FaMapMarkerAlt className="footer-icon" />Serving Shreveport-Bossier from Bossier, LA</p>
            <p><FaPhone className="footer-icon" /><a href="tel:+13186587801">(318) 658-7801</a></p>
            <p><FaEnvelope className="footer-icon" /><a href="mailto:support@tharpeindustries.com">support@tharpeindustries.com</a></p>
          </div>
        </div>
        
        <div className="footer-section">
          <h3>Services</h3>
          <ul className="footer-links">
            <li><Link to="/services">All Services</Link></li>
            <li><Link to="/it-health-check">IT Health Check</Link></li>
            <li><Link to="/managed-it-services">Managed IT Services</Link></li>
            <li><Link to="/computer-repair">Computer Repair</Link></li>
            <li><Link to="/cybersecurity">Cybersecurity / Backup</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Company</h3>
          <ul className="footer-links">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact-us">Contact</Link></li>
            <li><Link to="/how-to-choose-it-support">Resources / Guides</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Tharpe Industries. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
